/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputRestartTeamSession
 */
export interface InputRestartTeamSession {
    /**
     * 
     * @type {number}
     * @memberof InputRestartTeamSession
     */
    hours: number;
    /**
     * 
     * @type {number}
     * @memberof InputRestartTeamSession
     */
    positionId?: number;
}

/**
 * Check if a given object implements the InputRestartTeamSession interface.
 */
export function instanceOfInputRestartTeamSession(value: object): boolean {
    if (!('hours' in value)) return false;
    return true;
}

export function InputRestartTeamSessionFromJSON(json: any): InputRestartTeamSession {
    return InputRestartTeamSessionFromJSONTyped(json, false);
}

export function InputRestartTeamSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputRestartTeamSession {
    if (json == null) {
        return json;
    }
    return {
        
        'hours': json['hours'],
        'positionId': json['positionId'] == null ? undefined : json['positionId'],
    };
}

export function InputRestartTeamSessionToJSON(value?: InputRestartTeamSession | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hours': value['hours'],
        'positionId': value['positionId'],
    };
}

